<div class="row">
  <div class="col-12 col-sm-12">
    <div class="row">
      <div class="custom-container col-lg-4 col-md-4 col-sm-6 col-6 ">
        <label class="fw-bolder">Inventario</label>
        <p>{{inventoryName}}</p>
      </div>
      <div class="custom-container col-lg-4 col-md-4 col-sm-6 col-6">
        <label class="fw-bolder">Sucursal</label>
        <p>{{branchName}}</p>
      </div>
      <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-3">
        <label class="fw-bolder">Tipo Entrada</label>
        <p>Entrada</p>
      </div>
      <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-3">
        <label class="fw-bolder">Consecutivo</label>
        <p>{{inventoryEntryModel.consecutive}}</p>
      </div>
    </div>
    <div class="row my-3">
      <label>Para realizar el proceso de importación del detalle de la entrada, descargue la guía y siga los
        pasos:</label>
    </div>
    <div class="row">
      <div class="col-4 col-md-4">
        <app-custom-button [title]="'downloadGuideImport'" [label]="'Descargar Guía'" [severity]="'success'"
          [width]="'9.5rem'" (onClick)="downloadGuideImport()"></app-custom-button>
      </div>
      <div class="col-8 col-md-8 d-flex justify-content-end">
        <div class="d-flex gap-2">
          <input type="file" id="fileImport" (change)="getNameFile($event)"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden />
          <app-custom-button [title]="'Seleccionar archivo'" [label]="'Seleccionar archivo'" [width]="'8.5rem'"
            (onClick)="attachFileImport()"></app-custom-button>
          <p class="ms-2 mt-2">{{nameFile}}</p>
          <app-custom-button [title]="'Importar'" [label]="'Importar'" [variant]="undefined"
            (onClick)="importInventoryEntry()"></app-custom-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div id="list" *ngIf="visibleTxt">
        <h6>Lista de Errores y Alertas</h6>
        <p>Total errores: {{inventoryEntryDetailAlerts.length}}</p>
        <div id="container-alerts" *ngFor="let inventoryEntryDetailAlert of inventoryEntryDetailAlerts">
          <p [ngClass]="errorinventoryEntryDetail == 1 ? 'message-error' : 'message-alert'">
            {{inventoryEntryDetailAlert.message}}
          </p>
        </div>
      </div>
      <div class="row" *ngIf="visibleTxt">
        <div class="d-flex justify-content-end">
          <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'" [width]="'5.5rem'"
            (onClick)="downloadErrorsTxt()"></app-custom-button>
        </div>
      </div>
    </div>
  </div>
</div>